import { StepEstateLetterToFinancialInstitutionMeta } from '@/modules/guidancestep/models/meta/shared/StepEstateLetterToFinancialInstitutionMeta';

export class Step233636Meta extends StepEstateLetterToFinancialInstitutionMeta {}
